import cx from "classnames";
import Modal from "react-modal";

import Cross from "./cross.svg";

Modal.setAppElement("#modal-root");

export type WebsiteModalProps = Omit<
  Modal.Props,
  "preventScroll" | "appElement" | "bodyOpenClassName"
> & { className?: string };

export const WebsiteModal = ({
  children,
  className,
  ...props
}: WebsiteModalProps) => (
  <Modal
    className={cx(
      "flex justify-center items-center w-screen h-screen bg-lotion/30 backdrop-blur",
      className,
    )}
    preventScroll={true}
    bodyOpenClassName="overflow-hidden fixed w-full h-full"
    overlayClassName="fixed inset-0 bg-black/[.75] z-50"
    {...props}
  >
    <div className="relative p-12 w-[90vw] bg-white rounded-lg border drop-shadow-black lg:w-[55rem]">
      <Cross
        className="absolute top-6 right-6"
        onClick={props.onRequestClose}
      />
      {children}
    </div>
  </Modal>
);
